import { render, staticRenderFns } from "./clComparison.vue?vue&type=template&id=45b77f71&scoped=true"
import script from "./clComparison.vue?vue&type=script&lang=js"
export * from "./clComparison.vue?vue&type=script&lang=js"
import style0 from "./clComparison.vue?vue&type=style&index=0&id=45b77f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b77f71",
  null
  
)

export default component.exports